module.exports = __webpack_public_path__ + "img/mutesing.994f3d29.svg";